/* eslint-disable */
import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/payment-confirmed",
    name: "payment-confirmed",
    component: () =>
        import(/* webpackChunkName: "payment-confirmed" */ "../components/Payments/PaymentConfirmed.vue"),
  },
  {
      path: "/contributor",
      props: route => ({
      }),
    name: "contributor",
    component: () =>
        import(/* webpackChunkName: "contribution" */ "../components/Contributor/ContributionMain.vue"),
  },
  // {
  //   path: "/track",
  //   props: route => ({ query: { collection: route.query.collection, hasGroupCard: route.query.hasGroupCard, collectionclosedays: route.query.collectionclosedays, collectiontitle: route.query.collectiontitle}}),
  //   name: "contributor",
  //   component: () =>
  //       import(/* webpackChunkName: "track" */ "../components/Track/TrackMain.vue"),
  // }
];

const router = createRouter({
  history: createWebHistory(process.env.VUE_APP_BASE_URL),
  routes,
});
   
export default router;
